import { Box } from '@mui/material';

export enum SyberryTodayCountBadgeSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum SyberryTodayCountBadgeColor {
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
}

type SyberryTodayCountBadgeProps = {
  value: number;
  'aria-label'?: string;
  className?: string;
  size?: SyberryTodayCountBadgeSize;
  color?: SyberryTodayCountBadgeColor;
};

const SyberryTodayCountBadge = ({
  value,
  'aria-label': countLabel,
  className,
  size = SyberryTodayCountBadgeSize.MEDIUM,
  color = SyberryTodayCountBadgeColor.NEUTRAL,
}: SyberryTodayCountBadgeProps) => (
  <Box
    component="span"
    aria-label={countLabel}
    className={className}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      flex: '0 0 auto',
      border: '1px solid currentColor',
      borderRadius: '50%',
      lineHeight: 1,
      fontWeight: 500,
      fontSize: '12px',
      fontVariantNumeric: 'tabular-nums',
      ...(size === SyberryTodayCountBadgeSize.SMALL && {
        width: '21px',
        height: '21px',
      }),
      ...(size === SyberryTodayCountBadgeSize.MEDIUM && {
        width: '24px',
        height: '24px',
      }),
      ...(color === SyberryTodayCountBadgeColor.PRIMARY && {
        color: 'primary.main',
        fontSize: '13px',
      }),
      ...(color === SyberryTodayCountBadgeColor.NEUTRAL && {
        color: 'text.secondary',
      }),
    }}
  >
    {value}
  </Box>
);

export default SyberryTodayCountBadge;
